import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import IArborApplicantUserTypeMapping from "../../../../models/misconfig/arbor/userTypes/ArborApplicantUserTypeMapping";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { IArborUserTypeSubEditProps } from "./arbor-usertype-edit";

const ArborApplicantUserTypeEdit = forwardRef((props: IArborUserTypeSubEditProps, ref) => {
    const [arborConfig, setArborConfig] = useState<IArborApplicantUserTypeMapping | null>(null);
    const hasInitializedRef = useRef<boolean>(false);

    useEffect(() => {        
        if (props.configJson && !hasInitializedRef.current) {
            const configObj: IArborApplicantUserTypeMapping = JSON.parse(props.configJson);
            setArborConfig(configObj);
            hasInitializedRef.current = true;
        }
    }, [props.configJson]);

    useImperativeHandle(ref, () => ({
        validate: function() : boolean {
           return true;
        }}));

    const updateRequiredStatus = (value: string) => {
        setArborConfig(prev => ({...prev!, RequiredStatus: value}));
        props.handleChange('RequiredStatus', value);
    }

    const updateExcludeStatus = (index: number, value: string) => {
        const updatedR = [...arborConfig?.ExcludeStatuses || []];
        updatedR[index] = value;
        setArborConfig(prev => ({...prev!, ExcludeStatuses: updatedR}));
        props.handleChange('ExcludeStatuses', updatedR);
    }

    const removeExcludeStatus = (index: number) => {
        const updatedR = arborConfig?.ExcludeStatuses.filter((_, idx) => idx !== index) || [];
        setArborConfig(prev => ({...prev!, ExcludeStatuses: updatedR}));
        props.handleChange('ExcludeStatuses', updatedR);
    }

    const appendExcludeStatus = () => {
        const updatedR = [...arborConfig?.ExcludeStatuses || [], ''];
        setArborConfig(prev => ({...prev!, ExcludeStatuses: updatedR}));
        props.handleChange('ExcludeStatuses', updatedR);        
    }

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={props.firstCol} className="pt-2">Required status</Col>
                <Col md={props.secondCol}>
                    <input type="text" className="form-control mt-1 ms-0 w-100" value={arborConfig?.RequiredStatus || ''}
                        onChange={e => updateRequiredStatus(e.target.value)} />
                </Col>
            </Row>
            {arborConfig?.ExcludeStatuses?.map((value, idx) => (
            <Row className="pb-2" key={`excludeStatuses-${idx}`}>  
                <Col md={2}>{idx === 0 ? 'Excluded Statuses' : ''}</Col>
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Excluded Status"
                        value={value}
                        onChange={(e) => updateExcludeStatus(idx, e.target.value)} />
                </Col>
                <Col md={2}>
                    <button type="button" className="btn btn-light red-color" onClick={() => removeExcludeStatus(idx)}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                </Col>
            </Row>
            ))}
            <Row className="pb-3">
                <Col md={props.firstCol}>{
                        arborConfig === null 
                        || arborConfig.ExcludeStatuses === undefined 
                        || arborConfig.ExcludeStatuses.length === 0 ? 'Excluded Statuses' : ''
                    }</Col>
                <Col md={props.secondCol}>  
                    <button 
                        type="button" 
                        className="btn" 
                        onClick={() => appendExcludeStatus()}style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Excluded Status">+ Add New</button>
                </Col>
            </Row>            
        </React.Fragment>
    );
});

export default ArborApplicantUserTypeEdit;